import React, {Component} from 'react';
import PropTypes from 'prop-types';

const AWAIT_FOR_RENDER_TIMEOUT = 300;
const WATCH_TIMEOUT = 100;

class AccordionItem extends Component {

    static propTypes = {
        index: PropTypes.number.isRequired,
        onToggle: PropTypes.func.isRequired,
        title: PropTypes.object.isRequired,
        opened: PropTypes.bool.isRequired,
        blockTitleClass: PropTypes.string,
        closedTitleClass: PropTypes.string,
        openedTitleClass: PropTypes.string,
        blockBodyClass: PropTypes.string,
        closedBodyClass: PropTypes.string,
        openedBodyClass: PropTypes.string,
    };

    constructor() {
        super();
        this.handleToggle = this.handleToggle.bind(this);
        this.startHeightWatching = this.startHeightWatching.bind(this);
        this.state = {
            bodyHeight: "",
            opened: false,
            isNeedStartHeightWatching: false
        };
        this.awaitRenderDescriptor = null;
        this.awaitHeightDescriptor = null;
    }

    handleToggle() {
        this.props.onToggle(this.props.index);
    }

    shouldComponentUpdate(nextProps, nextState) {
        return this.props.opened !== nextProps.opened ||
            this.props.children !== nextProps.children ||
            this.state.bodyHeight !== nextState.bodyHeight;
    }

    startHeightWatching() {
        if (this.refs.body) {
            this.setState({
                bodyHeight: this.refs.body.getBoundingClientRect().height,
            });
            this.awaitHeightDescriptor = setTimeout(this.startHeightWatching, WATCH_TIMEOUT);
        }
    }

    stopHeightWatching() {
        clearTimeout(this.awaitHeightDescriptor);
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        if (nextProps.opened !== prevState.opened) {
            const newState = { ...prevState, opened: nextProps.opened };

            if (nextProps.opened) {
                newState.isNeedStartHeightWatching = true;
            } else {
                newState.isNeedStartHeightWatching = false;
            }

            return newState
        }

        return null;
    }

    componentDidMount() {
        this.awaitRenderDescriptor = setTimeout(() => {
            if (this.props.opened) {
                this.startHeightWatching();
            }
        }, AWAIT_FOR_RENDER_TIMEOUT);
    }

    componentDidUpdate() {
        if (this.state.isNeedStartHeightWatching) {
            this.startHeightWatching();
        } else {
            this.setState({ bodyHeight: 0 });
            this.stopHeightWatching();
        }
    }

    componentWillUnmount() {
        clearTimeout(this.awaitRenderDescriptor);
        this.stopHeightWatching();
    }

    render() {
        return (
            <div className="accordionItem">
                <div className={
                        [
                            this.props.blockTitleClass,
                            this.props.opened ? this.props.openedTitleClass : this.props.closedTitleClass,
                        ].filter(x => x).join(' ')
                    }
                    onClick={this.handleToggle}>
                    {this.props.title}
                </div>
                <div className={
                    [
                        this.props.blockBodyClass,
                        this.props.opened ? this.props.openedBodyClass : this.props.closedBodyClass,
                    ].filter(x => x).join(' ')
                } style={{height: this.state.bodyHeight}}>
                    <div ref="body">
                        {this.props.children}
                    </div>
                </div>
            </div>
        );
    }
}

export default AccordionItem;